import { render, staticRenderFns } from "./YStepper.vue?vue&type=template&id=a4e74dca&scoped=true&lang=pug&"
import script from "./YStepper.vue?vue&type=script&lang=js&"
export * from "./YStepper.vue?vue&type=script&lang=js&"
import style0 from "./YStepper.vue?vue&type=style&index=0&id=a4e74dca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e74dca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VDivider,VLayout})
